import { useEffect } from 'react';

const RESIZER = 'https://www.civitatis.com/f/js/vendor/iframeResizer.min.js';

/**
 * Carga el iframeResizer de Civitatis (una sola vez) y ajusta la altura de los iframes
 * marcados con data-civitatis mientras la pestaña de tours está activa.
 * @param {boolean} activo
 */
export default function useCivitatisResizer(activo) {
  useEffect(() => {
    if (!activo) return;
    const run = () => {
      if (!window.iFrameResize) return;
      document.querySelectorAll('iframe[data-civitatis]').forEach((f) => { if (!f.iFrameResizer) window.iFrameResize({ checkOrigin: false, log: false }, f); });
    };
    let s = document.querySelector(`script[src="${RESIZER}"]`);
    if (!s) { s = document.createElement('script'); s.src = RESIZER; s.async = true; s.onload = run; document.head.appendChild(s); } else setTimeout(run, 60);
  }, [activo]);
}
